import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('footerPrivacy')} | CSSBuy Spreadsheet`;
  }, [t]);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">{t('footerPrivacy')}</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('footerPrivacy')}
            </h1>

            <div className="space-y-6">
              <p className="text-foreground-700 leading-relaxed">
                Esta Política de Privacidade descreve como coletamos, usamos e protegemos suas informações pessoais ao usar este website.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Informações Coletadas</h2>
              <p className="text-foreground-700 leading-relaxed">
                Podemos coletar informações básicas como nome e email quando você entra em contato conosco através do formulário de contato. Não vendemos ou compartilhamos suas informações pessoais com terceiros.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Uso de Cookies</h2>
              <p className="text-foreground-700 leading-relaxed">
                Este website pode usar cookies para melhorar a experiência do usuário. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar a funcionalidade do website.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Segurança</h2>
              <p className="text-foreground-700 leading-relaxed">
                Tomamos medidas razoáveis para proteger suas informações pessoais. No entanto, nenhum método de transmissão pela internet é 100% seguro.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Alterações na Política</h2>
              <p className="text-foreground-700 leading-relaxed">
                Podemos atualizar esta política periodicamente. Recomendamos revisar esta página regularmente para se manter informado sobre quaisquer alterações.
              </p>

              <div className="bg-background-100 rounded-2xl p-6 md:p-8 mt-8">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  Se você tiver dúvidas sobre esta política de privacidade, entre em contato conosco através da página de <Link to="/contact" className="text-primary-600 hover:underline">contato</Link>.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}